

const isDev = process.env.NODE_ENV !== 'production';
const baseURL=isDev?'http://localhost:5050/api/v1':'https://api.leltek.com/api/v1'
module.exports={
    
    baseURL:baseURL
}